import { RangerResolverBase } from './ranger.resolver.base';
import { RangerService } from './ranger.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class RangerResolver extends RangerResolverBase {

  constructor(protected service: RangerService) {
    super(service);
  }
}



